class NYUClassData {
  constructor(data) {
    this.nyu_course_id = data.nyu_course_id;
    this.subject_code = data.subject_code;
    this.course_title = data.course_title;
  }
}

export default NYUClassData;
